export function testImage(url: string) : Promise<any> {
  const imgPromise = new Promise(function imgPromise(resolve, reject): any {
    const imgElement = new Image();
    imgElement.addEventListener('load', function imgOnLoad() {
      resolve(this);
    });

    imgElement.addEventListener('error', function imgOnError() {
      reject();
    })

    imgElement.src = url;
  });
  return imgPromise;
}
